var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",on:{"click":function($event){return _vm.updateWidgetInfoView($event)}}},[_c('div',{staticClass:"block mb-0"},[_c('div',{staticClass:"block-content d-flex"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }